import { useMachine } from '@xstate/react'
import { useEffect } from 'react'

import { Client, Strategy } from '../types'
import { BusinessUnitEditor } from './business-unit-editor'
import { editBusinessUnitMachine } from './edit-business-unit.state'

export type Props = {
  client: Client
  clientId: string
  isSaveSuccess: boolean
  onSaveSuccess: () => void
  strategies: Strategy[]
}

export function AddBusinessUnit({
  client,
  clientId,
  isSaveSuccess,
  onSaveSuccess,
  strategies
}: Props) {
  const [machine, send] = useMachine(editBusinessUnitMachine)
  const state = machine.context

  useEffect(() => {
    send({ type: 'INIT_ADD', clientId, onSaveSuccess })
  }, [clientId, onSaveSuccess, send])

  return (
    <BusinessUnitEditor
      businessUnit={state.businessUnit}
      client={client}
      errorMessages={state.errorMessages}
      errors={state.errors}
      isSaveSuccessful={isSaveSuccess}
      saveButtonText="Add"
      strategies={strategies}
      onMutate={mutation => send({ type: 'MUTATE', mutation })}
      onSave={businessUnit => send({ type: 'SAVE_CREATE', businessUnit })}
    />
  )
}
